import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { User } from '../../../model/user';
import { InternalMsgService } from '../../../shared/internal.msg.service';
import { SysadminServiceService } from '../../../shared/sysadmin-service.service';
import { StatusMessagesService } from '../../../shared/statusmessage.service';
import { BatchJobStatusItem } from '../../../model/batchjobstatusitem';

@Component({
    selector: 'batch-job-status-dialog',
    templateUrl: 'batch-job-status-dialog.html',
    styleUrls: ['batch-job-status-dialog.scss']
})
export class BatchJobStatusDialog implements OnInit {
    @Input() showMe: boolean = false;

    @Output() onCloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();

    batchJobStatusList: BatchJobStatusItem[] = [];

    loggedUser: User = new User();
    showLoading: boolean = false;
    visiblePage: string = 'email-batch-job-status';

    constructor(
        private userService: UserService,
        private sysadminService: SysadminServiceService,
        private statusMessagesService: StatusMessagesService,
        private msgService: InternalMsgService,
    ) { }

    ngOnInit() {
        this.initServices();
    }

    initServices() {
        this.loggedUser = this.userService.getUser();
    }

    closeDialog() {
        this.showMe = false;
        this.onCloseDlg.emit(true);
    }

    isSysAdmin(): boolean {
        return this.loggedUser.accessFeatures.includes('sysadmin');
    }

    showThis(value: string) {
        if (value === undefined)
            return;
        this.visiblePage = value;
    }
}
